import {
  CardStyleInterpolators,
  StackScreenProps,
} from "@react-navigation/stack";
import {
  createStackHeaderNavigator,
  ModalCloseButton,
} from "@towersystems/roam-common-native";
import { ProductDescriptionLlmQuickWinRootParamList } from "../../../../types";
import { ProductDescriptionReviewScreen } from "./ProductDescriptionReviewScreen";
import { GenerateProductDescriptionRootScreen } from "./GenerateProductDescriptionRootScreen";
import React from "react";
import { ScreenContext } from "./common";
import { useFormContext } from "react-hook-form";
import { ProductFormValues } from "../../components/ProductForm/types";

export type ProductDescriptionLlmQuickWinRootScreenProps = StackScreenProps<
  any,
  "ProductDescriptionLlmQuickWinRootScreen"
>;

const StackNavigator =
  createStackHeaderNavigator<ProductDescriptionLlmQuickWinRootParamList>();

export const ProductDescriptionLlmQuickWinRootScreen = ({
  navigation,
}: ProductDescriptionLlmQuickWinRootScreenProps) => {
  const { setValue: setProductFormValue } = useFormContext<ProductFormValues>();

  // need to use a screen context so the child form does not overwrite the parent form context
  const handleOnSubmit = (newDescription: string) => {
    setProductFormValue("description", newDescription, {
      shouldDirty: true,
      shouldTouch: true,
      shouldValidate: true,
    });
    navigation.pop();
  };

  return (
    <ScreenContext.Provider
      value={{
        setProductDescription: handleOnSubmit,
      }}
    >
      <StackNavigator.Navigator
        screenOptions={{
          headerShown: true,
          headerLeft: () => <ModalCloseButton type="Cancel" />,
          animationEnabled: true,
          cardStyleInterpolator: CardStyleInterpolators.forHorizontalIOS,
          title: "",
        }}
      >
        <StackNavigator.Group
          screenOptions={{
            headerShown: false,
          }}
        >
          <StackNavigator.Screen
            name="GenerateProductDescriptionRootScreen"
            component={GenerateProductDescriptionRootScreen}
          />
        </StackNavigator.Group>
        <StackNavigator.Screen
          name="ProductDescriptionReviewScreen"
          component={ProductDescriptionReviewScreen}
        />
      </StackNavigator.Navigator>
    </ScreenContext.Provider>
  );
};
